import firebase from 'firebase/app'
import ReactGA from 'react-ga'
import queryString from 'query-string'
import config from '../config'

const delistEbay = (offerID, itemID) => {

  ReactGA.event({
    category: 'Delist',
    action: 'Delist Ebay',
  })

  return new Promise(async (resolve, reject) => {
    const currentUser = firebase.auth().currentUser
    if (!currentUser) {
      return reject(new Error('Not logged in'))
    }

    const token = await currentUser.getIdToken(true)
    try {
      const queryParams = queryString.stringify({ token, offerID, itemID })

      console.log('About to list on ebay with offerID: ', offerID)
      
      const result = await fetch(`${config.cloudFunctionBaseURL}/ebayDelist?${queryParams}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      const json = await result.json()
      console.log('Got json response: ', json)
      resolve(json)
    }
    catch (e) {
      return reject(e)
    }
  })
}

export default delistEbay
